import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCogs } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import PageTitle from 'components/PageTitle';
import TableWrapper from 'components/TableWrapper';
import TableHeader from 'components/TableHeader';
import TableSubHeader from 'components/TableSubHeader';
import TableButton from 'components/TableButton';
import FilterInput from 'components/FilterInput';
import TableNoData from 'components/TableNoData';
import Loading from 'components/Loading';

import useMarketingProducts from 'hooks/useMarketingProducts';

import filter from 'utils/filter';
import formatCurrency from 'utils/formatCurrency';

import hashIds from 'services/hashIds';

const Products: React.FC = () => {
  const { t } = useTranslation();

  const [filterText, setFilterText] = useState('');

  const { marketingProducts, isLoading } = useMarketingProducts();

  const filteredMarketingProducts = filter(
    marketingProducts,
    ['produto'],
    filterText,
  );

  return (
    <div>
      <PageTitle
        icon={<FaCogs color="#FFFFFF" size={24} />}
        title={t('titles:marketing.title')}
        description={t('titles:marketing.description')}
      />

      <TableWrapper>
        <TableHeader
          title="Produtos"
          description="Produtos para Automação de Marketing da Hostnet."
          helpContent={
            <div>
              <p>{t('pages:customizedServices.helpContent.p1')}</p>
            </div>
          }
        />
        <TableSubHeader>
          <div />
          <div>
            <FilterInput onChange={value => setFilterText(value)} />
          </div>
        </TableSubHeader>

        <div className="datatables-table">
          <DataTable
            dense
            noHeader
            pagination
            columns={[
              {
                width: '90px',
                name: '',
                cell: ({ idProduto }) => (
                  <TableButton
                    forwardedAs={Link}
                    className="btn-in-table"
                    to={`/automacao-marketing/produtos/${hashIds.encode(
                      idProduto,
                    )}/venda`}
                  >
                    Vender
                  </TableButton>
                ),
              },
              {
                name: 'Item',
                selector: 'produto',
              },
              {
                name: 'Valor',
                selector: 'valor',
                sortable: true,
                cell: row => {
                  if (row.idProdutoCategoria === 42) {
                    return `A partir de ${formatCurrency(row.valor)}/mês`;
                  }

                  return `${formatCurrency(row.valor)}/mês`;
                },
              },
            ]}
            data={filteredMarketingProducts}
            progressPending={isLoading}
            progressComponent={<Loading />}
            noDataComponent={<TableNoData text={t('common:noDataToList')} />}
            paginationComponentOptions={{
              rowsPerPageText: t('common:registersPerPage'),
              rangeSeparatorText: t('common:of'),
            }}
            className="datatables-table"
          />
        </div>
      </TableWrapper>
    </div>
  );
};

export default Products;
